// import { useEffect, useRef, useState } from "react";
// import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
// import PauseIcon from "@mui/icons-material/Pause";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import ProductCard from "./index";
// import ProductCartCardBox from "components/ProductCartCardBox";

// const SLIDE_DURATION = 8000; // 8 seconds

// const ProductSlider = ({homeFeaturedProducts}) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));   // <600px
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px
//   const cardsPerView = isMobile ? 1 : isTablet ? 2 : 3;
//   console.log("cardsPerView", homeFeaturedProducts);
//   const sliderRef = useRef(null);

//   const [index, setIndex] = useState(0);
//   const [progress, setProgress] = useState(0);
//   const [paused, setPaused] = useState(false);

//   const PRODUCTS = [
//     { id: 1, image: "/images/product-5.png", title: "Chocolate Delight", price: 280, originalPrice: 300 },
//     { id: 2, image: "/images/product-6.png", title: "Vanilla Dream", price: 320, originalPrice: 360 },
//     { id: 3, image: "/images/product-3.png", title: "Strawberry Bliss", price: 290, originalPrice: 340 },
//     { id: 4, image: "/images/product-4.png", title: "Red Velvet Love", price: 350, originalPrice: 400 },
//   ];

//   const maxIndex = PRODUCTS.length - cardsPerView;
//   const scrollToIndex = (i) => {
//     if (!sliderRef.current) return;

//     const sliderWidth = sliderRef.current.offsetWidth;
//     const cardWidth = sliderWidth / cardsPerView;

//     sliderRef.current.scrollTo({
//       left: cardWidth * i,
//       behavior: "smooth",
//     });

//     setIndex(i);
//     setProgress(0);
//   };

//   // Auto-slide
//   useEffect(() => {
//     if (paused) return;

//     const interval = setInterval(() => {
//       setProgress((prev) => {
//         if (prev >= 100) {
//           const nextIndex = index >= maxIndex ? 0 : index + 1;
//           scrollToIndex(nextIndex);
//           return 0;
//         }
//         return prev + 100 / (SLIDE_DURATION / 100);
//       });
//     }, 100);

//     return () => clearInterval(interval);
//   }, [paused, index, maxIndex]);

//   // Sync index on manual scroll
//   const handleScroll = () => {
//     if (!sliderRef.current) return;

//     const sliderWidth = sliderRef.current.offsetWidth;
//     const cardWidth = sliderWidth / cardsPerView;
//     const newIndex = Math.round(sliderRef.current.scrollLeft / cardWidth);

//     setIndex(newIndex);
//     setProgress(0);
//   };

//   return (
//     <Box sx={{ width: "95%", mx: "auto" }}>
//       {/* SCROLLABLE SLIDER */}
//       <Box
//         ref={sliderRef}
//         onScroll={handleScroll}
//         sx={{
//           display: "flex",
//           overflowX: "auto",
//           scrollBehavior: "smooth",
//           scrollbarWidth: "none",
//           "&::-webkit-scrollbar": { display: "none" },
//         }}
//       >
//         {PRODUCTS.map((product) => (
//           <Box
//             key={product.id}
//             className="my-4"
//             sx={{
//               flex: `0 0 ${100 / cardsPerView}%`,
//               display: "flex",
//               p:3,
//               justifyContent: "center",
//                "&:hover": {
//         border: "1px solid #E8C2CF",
//         borderRadius: "16px",
//         transform: "translateY(-6px)",
//       },
//             }}
//           >
//             <ProductCartCardBox />
//           </Box>
//         ))}
//       </Box>
// <Box
//   sx={{
//     display: "flex",
//     justifyContent: "center", // center controls on screen
//     mt: 3,
//     width: "100%",
//   }}
// >
//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       gap: 2,
//       width: { xs: "90%", sm: "60%", md: "30%" }, // responsive width
//     }}
//   >
//     {/* Pause / Play */}
//     <IconButton
//       onClick={() => setPaused(!paused)}
//       sx={{
//         width: 40,
//         height: 40,
//         backgroundColor: "#E8C2CF",
//         color: "#771237",
//         "&:hover": {
//           backgroundColor: "#E8C2CF",
//         },
//       }}
//     >
//       {paused ? <PlayArrowIcon /> : <PauseIcon />}
//     </IconButton>

//     {/* Progress Bar */}
//     <Box
//       sx={{
//         flex: 1,
//         height: 6,
//         backgroundColor: "#E8C2CF",
//         borderRadius: "999px",
//         overflow: "hidden",
//       }}
//     >
//       <Box
//         sx={{
//           height: "100%",
//           width: `${progress}%`,
//           backgroundColor: "#771237",
//           transition: "width 0.1s linear",
//         }}
//       />
//     </Box>
//   </Box>
// </Box>

//     </Box>
//   );
// };

// export default ProductSlider;

import { useEffect, useRef, useState } from "react";
import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ProductCartCardBox from "components/ProductCartCardBox";
import globalRequest from "utils/global/globalRequest";
import * as APIS from "utils/helper/Enum";
import * as CUSTOM from "utils/helper/custom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const SLIDE_DURATION = 8000; // 8 sec
const LIMIT = 4;

const ProductSlider = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const cardsPerView = isMobile ? 1 : isTablet ? 2 : 3;
  const sliderRef = useRef(null);

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // ✅ NEW: Wishlisted product IDs ka Set — O(1) lookup ke liye
  const [wishlistedIds, setWishlistedIds] = useState(new Set());

  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [paused, setPaused] = useState(false);
  const [activeArrow, setActiveArrow] = useState(null);

  const maxIndex = Math.max(0, products.length - cardsPerView);

  // ✅ NEW: Wishlist fetch karo — user ke wishlisted product IDs ek Set me store karo
  const fetchWishlist = async () => {
    try {
      const response = await globalRequest(
        APIS.WISHLIST.GET_WISHLIST,
        "get",
        {},
        { params: { page: 1, limit: 1000 } }, // sabhi wishlist items ek baar me
        true
      );
      const items = response?.data?.data?.data || [];
      // ✅ Sirf productId ka Set banao — fast lookup ke liye
      const ids = new Set(items.map((item) => item?.productId));
      setWishlistedIds(ids);
    } catch (err) {
      // ✅ Wishlist error pe products normal dikhenge — silently fail
      console.error("Wishlist fetch error", err);
    }
  };

  const fetchProducts = async () => {
    if (!hasMore) return;

    try {
      const response = await globalRequest(
        APIS.PRODUCTS.All_PRODUCTS,
        "get",
        {},
        {
          params: {
            page,
            limit: LIMIT,
          },
        },
        true
      );

      const apiData = response?.data?.data?.data || [];

      if (apiData.length) {
        setProducts((prev) => [...prev, ...apiData]);
        setPage((prev) => prev + 1);
        if (apiData.length < LIMIT) setHasMore(false);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.error("Slider API error", err);
      setHasMore(false);
    }
  };

  // ✅ NEW: Products aur wishlist dono saath fetch karo on mount
  useEffect(() => {
    fetchProducts();
    fetchWishlist(); // ← wishlist bhi fetch hogi page load pe
  }, []);

  const scrollToIndex = (i) => {
    if (!sliderRef.current) return;

    const sliderWidth = sliderRef.current.offsetWidth;
    const cardWidth = sliderWidth / cardsPerView;

    sliderRef.current.scrollTo({
      left: cardWidth * i,
      behavior: "smooth",
    });

    setIndex(i);
    setProgress(0);
    if (i >= products.length - cardsPerView - 1 && hasMore) {
      fetchProducts();
    }
  };

  useEffect(() => {
    if (paused || products.length <= cardsPerView) return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          const next = index >= maxIndex ? 0 : index + 1;
          scrollToIndex(next);
          return 0;
        }
        return prev + 100 / (SLIDE_DURATION / 100);
      });
    }, 100);

    return () => clearInterval(interval);
  }, [paused, index, maxIndex, products.length]);

  /* Manual scroll sync */
  const handleScroll = () => {
    if (!sliderRef.current) return;

    const sliderWidth = sliderRef.current.offsetWidth;
    const cardWidth = sliderWidth / cardsPerView;
    const newIndex = Math.round(sliderRef.current.scrollLeft / cardWidth);

    setIndex(newIndex);
    setProgress(0);
  };

  const handlePrev = () => {
    setActiveArrow("left");
    const prevIndex = index <= 0 ? maxIndex : index - 1;
    scrollToIndex(prevIndex);
    setTimeout(() => setActiveArrow(null), 250);
  };

  const handleNext = () => {
    setActiveArrow("right");
    const nextIndex = index >= maxIndex ? 0 : index + 1;
    scrollToIndex(nextIndex);
    setTimeout(() => setActiveArrow(null), 250);
  };

  if (!products.length) return null;

  return (
    <Box sx={{ width: "100%", pl: "2%" }}>
      <Box
        ref={sliderRef}
        onScroll={handleScroll}
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {products.map((product) => (
          <Box
            key={product.id}
            sx={{
              flexShrink: 0,
              mr: 3, // gap between cards
              transition: "all 0.3s ease",
              "&:hover": {
                border: "1px solid #E8C2CF",
                borderRadius: "16px",
                transform: "translateY(-6px)",
              },
            }}
          >
            <ProductCartCardBox
              productId={product.id}
              productimage={CUSTOM.getImage(
                product?.productUoms?.[0]?.productUomImages?.[0]?.image
              )}
              productName={`${CUSTOM.getdataByLangKey(
                product?.productLocales,
                "",
                "name"
              )} - ${product?.productUoms?.[0]?.name || ""}`}
              discountedPrice={product?.productUoms?.[0]?.sellingPrice}
              originalPrice={
                product?.productUoms?.[0]?.actualPrice !==
                product?.productUoms?.[0]?.sellingPrice
                  ? product?.productUoms?.[0]?.actualPrice
                  : ""
              }
              isRecommended={product?.isRecommended}
              isBestSeller={product?.isBestseller}
              slug={product?.slug}
              uomData={product?.productUoms?.[0]}
              // ✅ NEW: wishlist status pass karo — Set me productId hai to true, warna false
              isWishlist={wishlistedIds.has(product.id)}
            />
          </Box>
        ))}
      </Box>

      {/* CONTROLS */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: { xs: "95%", md: "35%" } }}>
          <IconButton
            onClick={() => setPaused(!paused)}
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "#E8C2CF",
              color: "#771237",
              "&:hover": { backgroundColor: "#E8C2CF" },
            }}
          >
            {paused ? <PlayArrowIcon /> : <PauseIcon />}
          </IconButton>

          <Box sx={{ flex: 1, height: 6, backgroundColor: "#E8C2CF", borderRadius: 999 }}>
            <Box
              sx={{
                height: "100%",
                width: `${progress}%`,
                backgroundColor: "#771237",
                transition: "width 0.1s linear",
              }}
            />
          </Box>

          {/* Left Arrow */}
          <IconButton
            onClick={handlePrev}
            sx={{
              width: 35,
              height: 35,
              left: { xs: "auto", sm: "90%", md: "90%" },
              borderRadius: "50%",
              backgroundColor: activeArrow === "left" ? "#E8C2CF" : "transparent",
              transition: "all 0.25s ease",
              "&:hover": { backgroundColor: "#E8C2CF" },
            }}
          >
            <ArrowBackIcon sx={{ fontSize: 18 }} />
          </IconButton>

          {/* Right Arrow */}
          <IconButton
            onClick={handleNext}
            sx={{
              width: 35,
              height: 35,
              left: { xs: "auto", sm: "90%", md: "90%" },
              borderRadius: "50%",
              backgroundColor: activeArrow === "right" ? "#E8C2CF" : "transparent",
              transition: "all 0.25s ease",
              "&:hover": { backgroundColor: "#E8C2CF" },
            }}
          >
            <ArrowForwardIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductSlider;